goog.provide('el8.appchart.visitNote.util');

goog.require('el8.data.visitNoteFormTemplates');

el8.appchart.visitNote.util = (function() {

    return {
        getCurrFormTemplate: function(template) {
            return el8.data.visitNoteFormTemplates.getByIdentifier(template);
        },
        getReferenceInfo: function(item, isAutoGen) {

            var sectionName = '';

            var documentId = null,
                labResultId = null,
                patientItemId = null,
                handoutId = null,
                imoIds = null;

            switch(item.getModelClass()) {
                case 'ClinicalFormCollection':
                    var typeMap = {
                        'psychological': 'data',
                        'exercise': 'ros-Exercise',
                        'diet': 'ros-Diet'
                    };
                    // default to 'data'
                    sectionName = typeMap[item.getClinicalForm().getHistoryType()] || 'data';
                    patientItemId = item.getId();
                    break;
                case 'PatientHistoryItem':
                    var typeMap = {
                        'Past': 'past',
                        'Surgical': 'surgical',
                        'Social': 'social',
                        'Family': 'family',
                        'Habits': 'habits',
                        'Diet': 'ros-Diet',
                        'Exercise': 'ros-Exercise',
                        'Legal': 'data',
                        'Consultation': 'data',
                        'Immunization': 'data',
                        'Maintenance': 'data',
                        'Cognitive': 'ros',
                        'Functional': 'ros',
                        'Psychological': 'data'
                    };
                    // Default to 'social'
                    sectionName = sectionName || typeMap[item.getType()] || 'social';
                    patientItemId = item.getId();
                    break;
                case 'PatientFamilyHistoryItem':
                    sectionName = sectionName || 'family';
                    patientItemId = item.getId();
                    break;
                case 'PatientDrugIntolerance':
                case 'PatientAllergy':
                    sectionName = sectionName || 'problem';
                    patientItemId = item.getId();
                    break;
                case 'PatientImmunization':
                case 'PatientImmunizationDecline':
                    sectionName = sectionName || 'problem';
                    patientItemId = item.getId();
                    break;
                case 'PatientSmokingStatus':
                    sectionName = sectionName || 'habits';
                    patientItemId = item.getId();
                    break;
                case 'PatientProblem':
                    sectionName = sectionName || 'problem';
                    patientItemId = item.getId();
                    imoIds = item.getImoIds();
                    break;
                case 'DiscontinueMedOrder':
                case 'MedOrder':
                    sectionName = sectionName || 'med';
                    documentId = item.isRxDownload() ? null : item.getId();
                    break;
                case 'LabResult':
                    sectionName = sectionName || 'data';
                    labResultId = item.getId();
                    documentId = item.getReportId();
                    break;
                case 'Report':
                    sectionName = sectionName || 'data';
                    documentId = item.getId();
                    break;
                case 'RxHistoryDownloadSummary':
                    sectionName = sectionName || 'data';
                    documentId = item.getId();
                    break;
                case 'Handout':
                    sectionName = sectionName || 'instr';
                    handoutId = item.getId();
                    break;
                case 'Letter':
                case 'LetterReceipt':
                    sectionName = sectionName || 'tx';
                    documentId = item.getId();
                    break;
                default:
                    sectionName = sectionName || 'data';
                    documentId = item.getId();
                    break;
            }

            return {
                sectionName: sectionName,
                documentId: documentId,
                labResultId: labResultId,
                patientItemId: patientItemId,
                handoutId: handoutId,
                imoIds: imoIds
            };

        }
    };

})();
